import EventsSerializer from './base';

export default class Event extends EventsSerializer {}
